var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-option",class:{'is-open': _vm.isOpen}},[_c('div',{staticClass:"list-button",on:{"click":_vm.toggleNavigation}},[_vm._t("title")],2),_vm._t("options")],2)}
var staticRenderFns = []

export { render, staticRenderFns }